const AUTO_START_PARAM = "autostart";

export function shouldAutoStartExperience(location: Location = window.location): boolean {
  const url = new URL(location.href);
  return url.searchParams.get(AUTO_START_PARAM) === "1";
}
